import classNames from "classnames";
import { endOfMonth, format, parseISO } from "date-fns";
import ptBR from "date-fns/locale/pt-BR";
import download from "downloadjs";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useState } from "react";
import { FaCalendarAlt, FaFileExcel, FaFilePdf, FaSearch } from "react-icons/fa";
import { toast } from "react-toastify";
import AppCard from "../../../../components/appCard";
import { NegotiationDetail } from "../../../../components/dashboard/inadimplencias/listagem/detalhes";
import { Api } from "../../../../services/api";
import { CalendarPague, LargeTablePague } from "../../../../styles/primeReactConfig";
import formatDocument, { formatCurrency } from "../../../../utils/formatCurrency";
import GeraXLSX from "../../../../utils/GeraXLSX";


function BoletosAVencer() {
  const [diaInicial, setDiaInicial] = useState(new Date());
  const [diaFinal, setDiaFinal] = useState(endOfMonth(new Date()));
  const [showDiaInicial, setShowDiaInicial] = useState(new Date());
  const [showDiaFinal, setShowDiaFinal] = useState(endOfMonth(new Date()));
  const [showDetail, setShowDetail] = useState(false);
  const [mobile, setMobile] = useState(false);
  const [loading, setLoading] = useState(false);
  const [reload, setReload] = useState(false);
  const [rowCurrent, setRowCurrent] = useState([]);
  const [parcelas, setParcelas] = useState([]);
  const [soma, setSoma] = useState(0);
  const [first, setFirst] = useState(0)
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [total, setTotal] = useState(0);


  const ScreenCheck = () => {
    if (window.screen.width < 480 || window.screen.height < 480) {
      setMobile(true)
    }
    else {
      setMobile(false)
    }
  }

  const getLabel = () => {
    if (loading) return "Buscando...";
    return "Buscar";
  }

  const buscaInfoRepasses = (event) => {
    event.preventDefault();
    receberInfoRepasses();
  }

  const receberInfoRepasses = async () => {
    setLoading(true);
    const formatInicial = format(diaInicial, "yyyy-MM-dd");
    const formatFinal = format(diaFinal, "yyyy-MM-dd");
    setShowDiaInicial(diaInicial);
    setShowDiaFinal(diaFinal);
    try {
      const { data } = await Api.get(`/relatorio/mensal/${formatInicial}/${formatFinal}/${limit}/${page}`);
      setParcelas(data.array_cobrancas);
      setTotal(data.count);
      setSoma(data.total_a_receber)
    } catch (error) {
      toast.error("Erro de Conexão com o servidor")
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  const downloadPDF = async () => {
    const formatInicial = format(diaInicial, "yyyy-MM-dd");
    const formatFinal = format(diaFinal, "yyyy-MM-dd");
    try {
      const { data } = await Api.get(`relatorio/aReceber/${formatInicial}/${formatFinal}`, { responseType: 'blob' });
      download(data, `Relatório-de-${formatInicial}-a-${formatFinal}.pdf`)
    } catch (error) {
      console.log(error)
    }
  }

  const downloadXLSX = async () => {
    const formatInicial = format(diaInicial, "yyyy-MM-dd");
    const formatFinal = format(diaFinal, "yyyy-MM-dd");
    try {
      const { data } = await Api.get(`relatorio/mensal/${formatInicial}/${formatFinal}/99999999/0`);
      let relatorioXLSX = data.array_cobrancas
      //const relatorioKeys = Object.keys(relatorioXLSX[0])
      const headers = ['Descrição', 'Valor Total', 'Valor Boleto', 'Parcela', 'Vencimento Boleto', 'Nome', 'Documento']
      const fields = ['cobranca_descricao', 'cobranca_total_pagamento', 'boleto_valor', 'parcelas', 'cobranca_data_vencimento', 'usuario_nome', 'usuario_documento']
      const parametrosXLSX = {
        data: relatorioXLSX,
        headers: headers,
        fields: fields,
        titulo: `Relatorio_a_receber_de_${formatInicial}_até_${formatFinal}`
      }
      GeraXLSX(parametrosXLSX)

    } catch (error) {
      console.log(error)
    }
  }

  function toastController(type, message) {
    toast(message, { type: type })
  }

  function onPage(event) {
    const startIndex = parseInt(event.first);
    setLimit(event.rows);
    setPage(event.page);
    setFirst(startIndex);
    setReload(prevReload => !prevReload);
  }

  useEffect(() => {
    window.addEventListener("resize", ScreenCheck);
    ScreenCheck()
    receberInfoRepasses();
  }, [reload])


  return (
    <div className="grid gap-4">
      {showDetail &&
        <NegotiationDetail
          rowInfo={rowCurrent}
          close={() => setShowDetail(false)}
          toast={toastController}
        />}
      <AppCard >
        <div className="grid gap-4">
          <h4 className="text-xl"><b>Relatório de Boletos a vencer</b></h4>
          <h6>Informe o período do Relatório</h6>
          <form onSubmit={(e) => buscaInfoRepasses(e)}>
            <div className="grid md:flex md:mt-3 items-end w-full" >
              <div className="grid w-full md:w-1/3 p-2" >
                <label htmlFor="first">Dia Inicial</label>
                <Calendar
                  inputId="first"
                  value={diaInicial}
                  minDate={new Date()}
                  locale="pt-BR"
                  dateFormat="dd/mm/yy"
                  pt={CalendarPague}
                  onChange={(e) => setDiaInicial(e.value)}
                  yearNavigator
                  yearRange="2020:2030"
                  mask="99/99/9999"
                  showIcon
                  showOnFocus={false}
                  icon={<FaCalendarAlt className={
                    classNames('px-4 rounded-r-lg',
                      'w-[50px] h-full',
                      'bg-sky-400 text-white hover:bg-sky-500',
                      'dark:bg-sky-500 dark:text-black dark:hover:bg-sky-400'
                    )}
                  />}
                  required
                  touchUI={mobile}
                />
              </div>
              <div className="grid w-full md:w-1/3 p-2" >
                <label htmlFor="last">Dia Final</label>
                <Calendar
                  inputId="last"
                  value={diaFinal}
                  minDate={diaInicial}
                  locale="pt-BR"
                  dateFormat="dd/mm/yy"
                  pt={CalendarPague}
                  onChange={(e) => setDiaFinal(e.value)}
                  yearNavigator
                  yearRange="2020:2030"
                  mask="99/99/9999"
                  showIcon
                  showOnFocus={false}
                  icon={<FaCalendarAlt className={
                    classNames('px-4 rounded-r-lg',
                      'w-[50px] h-full',
                      'bg-sky-400 text-white hover:bg-sky-500',
                      'dark:bg-sky-500 dark:text-black dark:hover:bg-sky-400'
                    )}
                  />}
                  required
                  touchUI={mobile}
                />
              </div>
              <div className="grid w-full md:w-1/4 p-2" >
                <Button
                  loading={loading}
                  icon={<FaSearch />}
                  iconPos="left"
                  label={getLabel()}
                  type="submit"
                  severity="success"
                />
              </div>
            </div>
          </form>
        </div>
      </AppCard>
      <AppCard >
        <div className="flex justify-between">
          <div>
            <h4 className="text-xl"><b>Boletos a vencer de {format(showDiaInicial, "d 'de' MMMM 'de' yyyy", { locale: ptBR })} a {format(showDiaFinal, "d 'de' MMMM 'de' yyyy", { locale: ptBR })}</b></h4>
          </div>
          <div className="flex gap-4">
            <Button
              severity="danger"
              icon={<FaFilePdf />}
              tooltip="Baixar como PDF"
              tooltipOptions={{ position: 'left' }}
              onClick={() => downloadPDF()} />
            <Button
              severity="success"
              icon={<FaFileExcel />}
              tooltip="Baixar como XLSX"
              tooltipOptions={{ position: 'left' }}
              onClick={() => downloadXLSX()} />
          </div>
        </div>
        {soma > 0 && <h5>Valor dos Boletos: {formatCurrency(soma)}</h5>}
        <div className="mt-4">
          <DataTable
            value={parcelas}
            lazy
            loading={loading}
            paginatorTemplate='CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown'
            currentPageReportTemplate="Exibindo {first} de {last} do total de {totalRecords}"
            onPage={onPage}
            paginator
            onSelectionChange={e => { setRowCurrent(e.value); setShowDetail(true) }}
            selectionMode="single"
            pt={LargeTablePague}
            rows={limit}
            first={first}
            totalRecords={total}
            emptyMessage="Sem repasses a receber no período informado"
          >
            <Column header="Descrição" field="cobranca_descricao" />
            <Column header="Valor Total" body={rowData => formatCurrency(rowData.cobranca_total_pagamento)} />
            <Column header="Valor Boleto" body={rowData => formatCurrency(rowData.boleto_valor)} />
            <Column header="Parcela" field="parcelas" />
            <Column header="Vencimento Boleto" body={rowData => format(parseISO(rowData.cobranca_data_vencimento), 'dd/MM/yyyy')} />
            <Column header="Nome" field="usuario_nome" />
            <Column header="Documento" body={rowData => formatDocument(rowData.usuario_documento)} />
          </DataTable>
        </div>
      </AppCard>
    </div>
  )
}
export default BoletosAVencer
